export default "__VITE_ASSET__B5hy333J__"